import axios, { AxiosRequestConfig } from 'axios';
import Cookies from 'js-cookie';
import { toast } from 'react-toastify';

/**
 * Send request to api
 * @param {string} url
 * @param {AxiosRequestConfig} options
 */
function send(url, options) {
  const fullUrl = process.env.REACT_APP_API + url;
  const token = Cookies.get('token');
  options = {
    ...options,
    url: fullUrl,
    headers: {
      ...options?.headers,
      Authorization: `Bearer ${token}`
    }
  };
  const result = axios.request(options);
  result.catch((error) => {
    if (!error.response) {
      return;
    }
    const { data } = error.response;
    toast.error(data.message);
  });
  return result;
}

export { send };
